import React, { useState } from 'react';
import { likesAPI } from '../../services/api';
import AlertModal from '../common/AlertModal';

const LikeButton = ({ type, id, initialLikesCount, initialIsLiked, isAuthenticated }) => {
  const [likesCount, setLikesCount] = useState(initialLikesCount);
  const [isLiked, setIsLiked] = useState(initialIsLiked);
  const [isLoading, setIsLoading] = useState(false);
  const [showAuthAlert, setShowAuthAlert] = useState(false);

  const handleLike = async () => {
    if (!isAuthenticated) {
      setShowAuthAlert(true);
      return;
    }

    if (isLoading) return;

    setIsLoading(true);
    const previousLiked = isLiked;
    const previousCount = likesCount;

    // Optimistic update
    setIsLiked(!isLiked);
    setLikesCount(isLiked ? likesCount - 1 : likesCount + 1);

    try {
      if (isLiked) {
        // Unlike
        if (type === 'video') {
          await likesAPI.unlikeVideo(id);
        } else {
          await likesAPI.unlikeComment(id);
        }
      } else {
        // Like
        if (type === 'video') {
          await likesAPI.likeVideo(id);
        } else {
          await likesAPI.likeComment(id);
        }
      }
    } catch (error) {
      console.error('Error toggling like:', error);
      // Revert on error
      setIsLiked(previousLiked);
      setLikesCount(previousCount);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={handleLike}
        disabled={isLoading}
        className={`flex items-center space-x-1.5 px-2.5 py-1 rounded-lg transition-all duration-200 ${
          isLiked
            ? 'text-brand-yellow'
            : 'text-gray-400 hover:text-brand-yellow'
        } ${isLoading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
      >
        <svg
          className="w-4 h-4"
          fill={isLiked ? 'currentColor' : 'none'}
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
          />
        </svg>
        <span className="text-sm font-medium">{likesCount}</span>
      </button>

      <AlertModal
        show={showAuthAlert}
        title="Sign In Required"
        message={`Please sign in to like this ${type === 'video' ? 'video' : 'comment'}.`}
        type="info"
        onClose={() => setShowAuthAlert(false)}
      />
    </>
  );
};

export default LikeButton;
